import { sanitiseEmbroideryTextWithin } from "../embroidery-text.js";

console.log("portal-basket.js loaded");

const html = document.documentElement;
const body = document.body;

const token = document.querySelector("meta[name=csrf-token]").getAttribute("content");
const removeBasketItemButtons = document.querySelectorAll(".remove_item a");
const quantityFields = document.querySelectorAll(".quantity_selector_quantity_field");

const customiseContainers = document.querySelectorAll(".basket_item .customisation_container");

const proceedToCheckoutButton = document.querySelector(".proceed_to_checkout .button");

let quantityTimers = {};

async function savePersonalisation(customiseContainer)
{
    const personalisationGroup = customiseContainer.querySelector(".personalise_as_group");
    const personalisationIndividual = customiseContainer.querySelector(".personalise_individually");

    const personalisationInputs = personalisationIndividual.querySelectorAll("[data-line]");

    const token = document.querySelector("meta[name=csrf-token]").getAttribute("content");
    const url = customiseContainer.getAttribute("data-save-url");

    let data = new FormData();

    personalisationInputs.forEach(personalisationInput => {
        const inputValue = personalisationInput.value.trim();
        data.append(personalisationInput.name, inputValue);
    });

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'X-CSRF-TOKEN': token
            },
            body: data
        });

        const result = await response.json();
        if (result.success)
        {
            //if we have pricing
            if (result.totalCost !== undefined)
            {
                const totalCost = parseFloat(result.totalCost);
                const totalCostIncVat = parseFloat(result.totalCostIncVat);

                const summaryTable = document.querySelector(".order_summary_column table.summary");
                const totalTable = document.querySelector(".order_summary_column table.totals");

                const totalPriceSelector = totalTable.querySelector(".total_price span.price");

                const personalisationRow = summaryTable.querySelector(".personalisation_row");

                if (totalPriceSelector)
                {
                    window.setPrice(totalPriceSelector,totalCost, totalCostIncVat);
                }

                const personalisationPriceSelector = personalisationRow.querySelector("span.price");

                //if we have personalisation costs
                if (result.personalisationCost !== undefined)
                {
                    const personalisationCost = parseFloat(result.personalisationCost);
                    const personalisationCostIncVat = parseFloat(result.personalisationCostIncVat);
                    if (personalisationRow)
                    {
                        personalisationRow.classList.add("visible");
                        window.setPrice(personalisationPriceSelector,personalisationCost, personalisationCostIncVat);
                    }
                }
                else
                {
                    if (personalisationRow)
                    {
                        personalisationRow.classList.remove("visible");
                        window.setPrice(personalisationPriceSelector,0, 0);
                    }
                }
            }

            if (result.groups && result.groups.length > 0)
            {
                result.groups.forEach(group => {
                    const groupContainer = document.querySelector('.basket_item[data-uuid="' + group.uuid + '"]');
                    if (groupContainer)
                    {
                        console.log("Updating group with uuid " + group.uuid);
                        const groupPersonalisationRowSelector = groupContainer.querySelector(".pricing_container .personalisation_cost");
                        const groupPersonalisationCostSelector = groupPersonalisationRowSelector .querySelector("span.price");
                        const groupSubtotalSelector = groupContainer.querySelector(".pricing_container .total span.price");

                        if (groupPersonalisationCostSelector)
                        {
                            window.setPrice(groupPersonalisationCostSelector,group.personalisationCost, group.personalisationCostIncVat);
                            groupPersonalisationRowSelector.classList.add("visible");
                        }
                        if (groupSubtotalSelector)
                        {
                            window.setPrice(groupSubtotalSelector,group.subtotal, group.subtotalIncVat);
                        }
                    }
                });
            }

        }
        return (result.success);
    } catch (error)
    {
        window.modal(error,"Error");
        return false;
    }

}

function validatePersonalisation(customiseContainer, ignoreUnsaved = false)
{
    const personalisationGroup = customiseContainer.querySelector(".personalise_as_group");
    const personalisationIndividual = customiseContainer.querySelector(".personalise_individually");

    if (personalisationIndividual)
    {
        let formType = "individual";
        let requiredFields = personalisationIndividual.querySelectorAll("[data-line='1'][data-required]");

        if (customiseContainer.classList.contains("as_group"))
        {
            formType = "group";
            requiredFields = personalisationGroup.querySelectorAll("[data-required]");
        }
    
        if (requiredFields)
        {
            let requiredFieldsValid = true;
            requiredFields.forEach(requiredField => {
                if (requiredField.value.trim() == "")
                {
                    requiredField.classList.add("error");
                    if (requiredFieldsValid) //first field with error, scroll into view and focus
                    {
                        if (requiredField.checkVisibility({opacityProperty: true}))
                        {
                            requiredField.scrollIntoView({
                                behavior: 'smooth',
                                block: 'center',
                                inline: 'center'
                            });
                            requiredField.focus();
                        }
                        else
                        {
                            customiseContainer.classList.add("unpersonalised_error");
                            customiseContainer.scrollIntoView({
                                behavior: 'smooth',
                                block: 'center',
                                inline: 'center'
                            });
                        }
                    }
                    requiredFieldsValid = false;
                }
            });
            if (!requiredFieldsValid)
            {
                return false;
            }
        }

        if (!ignoreUnsaved && customiseContainer.classList.contains("unsaved"))
        {
            customiseContainer.classList.add("unsaved_error");
            return false;
        }
    }

    return true;
}

document.addEventListener("DOMContentLoaded", () => {

    removeBasketItemButtons.forEach(removeBasketItemButton => {
        removeBasketItemButton.addEventListener("click", e => {
            e.preventDefault();

            const target = e.target;
            const basketUuids = JSON.parse(target.dataset.basketUuids);
            const removeItemUrl = target.dataset.removeUrl;

            fetch(removeItemUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-CSRF-TOKEN': token
                },
                body: JSON.stringify(basketUuids)
            })
            .then(response => response.json())
            .then(result => {
                window.location.reload();
            });
        });
    });

    quantityFields.forEach(quantityField => {
        quantityField.addEventListener("change", e => {
            e.preventDefault();
        
            const target = e.target;
            const quantityUrl = target.dataset.quantityUrl;
        
            let data = {
                'quantity': target.value
            };

            fetch(quantityUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-CSRF-TOKEN': token
                },
                body: JSON.stringify(data)
            })
                .then(response => response.json())
                .then(result => {
                    window.location.reload();
                });
        });
    });

    customiseContainers.forEach(customiseContainer => {
        const customiseButton = customiseContainer.querySelector(".button.personalise");
        const personalisationIndividualLink = customiseContainer.querySelector(".personalise_individually_link");
        const personalisationGroupLink = customiseContainer.querySelector(".personalise_as_group_link");
        const personalisationGroup = customiseContainer.querySelector(".personalise_as_group");
        const personalisationIndividual = customiseContainer.querySelector(".personalise_individually");
        const personalisationFields = customiseContainer.querySelectorAll("input[data-line]");
        sanitiseEmbroideryTextWithin(customiseContainer, "input[data-line]");
        if (customiseButton)
        {
            customiseButton.addEventListener("click", e => {
                e.preventDefault();

                customiseContainer.classList.remove("initial","unpersonalised_error");
                if (personalisationGroup) //if this basket group has more than one item...
                {
                    customiseContainer.classList.add("as_group");
                    customiseContainer.classList.remove("individually");
                    personalisationGroup.querySelector("[data-line='1']").focus();
                }
                else
                {
                    customiseContainer.classList.add("individually");
                    personalisationIndividual.querySelector("[data-line='1']").focus();
                }

            });
        }

        if (personalisationIndividual) //every customisable product group should have this
        {
            const saveButtons = customiseContainer.querySelectorAll("button.save");
            const individualInputs = personalisationIndividual.querySelectorAll("input[data-line]");

            if (personalisationIndividualLink)
            {
                personalisationIndividualLink.addEventListener("click", e => {
                    e.preventDefault();
                    customiseContainer.classList.add("individually");
                    customiseContainer.classList.remove("as_group");
                    customiseContainer.classList.remove("initial");
                    individualInputs.forEach(individualInput => {
                        individualInput.classList.remove("error");
                        individualInput.value = "";
                    });

                    personalisationIndividual.querySelector("[data-line='1']").focus();
                });
            }

            saveButtons.forEach(saveButton => {
                saveButton.addEventListener("click", async (e) => {
                    e.preventDefault;
                    let saveType = "individual";
                    let saveButtonToUpdate = saveButton;
                    if (saveButton.classList.contains("group"))
                    {
                        saveType = "group";
                    }

                    //if this is a group save, make sure we update the group button
                    if (customiseContainer.classList.contains("as_group"))
                    {
                        saveButtonToUpdate = customiseContainer.querySelector("button.save.group");
                    }

                    if (validatePersonalisation(customiseContainer,true))
                    {
                        if (saveType == "group")
                        {
                            //copy across to the individual fields
                            
                            const individualInputs = personalisationIndividual.querySelectorAll("[data-line]");
                            const groupInputs = personalisationGroup.querySelectorAll("[data-line]");
                            groupInputs.forEach(groupInput => {
                                const lineNumber = groupInput.getAttribute("data-line");
                                individualInputs.forEach(individualInput => {
                                    if (individualInput.getAttribute("data-line") == lineNumber)
                                    {
                                        individualInput.value = groupInput.value;
                                    }
                                });
                            });
                            
                            //trigger save on individual
                            customiseContainer.querySelector("button.save.individual").dispatchEvent(new Event('click'));
                        }
                        else
                        {
                            saveButtonToUpdate.classList.add("loading");
                            saveButtonToUpdate.disabled = true;
                            const saveResult = await savePersonalisation(customiseContainer);
                            saveButtonToUpdate.classList.remove("loading");
                            if (saveResult)
                            {
                                saveButtonToUpdate.classList.add("success");
                                customiseContainer.classList.remove("unsaved");
                                customiseContainer.classList.remove("unsaved_error");
                                customiseContainer.classList.add("saved");
                                saveButtonToUpdate.innerHTML = "Personalisation Saved";
                            }
                            else
                            {
                                window.modal("Your personalisation could not be saved. Please try again.","Sorry");
                                saveButtonToUpdate.disabled = false;
                                saveButtonToUpdate.innerHTML = saveButtonToUpdate.getAttribute("data-label");
                            }

                        }
                    }
                });
            });
        }

        if (personalisationGroup)
        {
            const groupInputs = personalisationGroup.querySelectorAll("[data-line]");
            if (personalisationGroupLink)
            {
                personalisationGroupLink.addEventListener("click", e => {
                    e.preventDefault();
                    customiseContainer.classList.add("as_group");
                    customiseContainer.classList.remove("individually");
                    customiseContainer.classList.remove("initial");

                    groupInputs.forEach(groupInput => {
                        groupInput.classList.remove("error");
                        groupInput.value = "";
                    });

                    personalisationGroup.querySelector("[data-line='1']").focus();
                });
            }
        }

        if (personalisationFields)
        {
            personalisationFields.forEach(personalisationField => {
                const saveButtons = customiseContainer.querySelectorAll("button.save");
                personalisationField.addEventListener("input", e =>
                {
                    saveButtons.forEach(saveButton => {
                        saveButton.classList.remove("success");
                        saveButton.innerHTML = saveButton.getAttribute("data-label");
                        saveButton.disabled = false;
                    });

                    customiseContainer.classList.remove("saved");
                    customiseContainer.classList.add("unsaved");
                    personalisationField.classList.remove("error");
                });
            });
        }

        if (proceedToCheckoutButton)
        {
            proceedToCheckoutButton.addEventListener("click", e => {
                customiseContainers.forEach(customiseContainer => {
                    if (!validatePersonalisation(customiseContainer))
                    {
                        e.preventDefault();
                    }
                });
            });
        }
    });
});